"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Link = require("../../ui/links/Link");
var _mediaQuery = require("../../../utils/mediaQuery");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Link = (0, _styledComponents.default)(_Link.Link)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  cursor: ", ";\n  &:hover,\n  &:active {\n    color: ", ";\n    text-decoration: none;\n  }\n  &:active {\n    text-decoration: underline;\n  }\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
}, function (_ref2) {
  var href = _ref2.href;
  return href ? 'pointer' : 'default';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.secondary;
}, _mediaQuery.mediaQuery.greaterThan('lg')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    white-space: nowrap;\n  "]))));
var MenuItem = (0, _styledComponents.default)(function (_ref4) {
  var link = _ref4.link,
    children = _ref4.children,
    className = _ref4.className,
    target = _ref4.target,
    id = _ref4.id;
  return /*#__PURE__*/_react.default.createElement(Link, {
    id: id,
    className: "".concat(className, " d-flex align-items-center"),
    href: link,
    target: target
  }, children);
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 10px;\n  &:last-child {\n    margin-bottom: 0;\n  }\n"])));
exports.MenuItem = MenuItem;